import { Layout, Menu, theme } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// Icons
import { default as dashboardIcon} from '../assets/guage.svg';
import contentIcon from '../assets/library.svg';
import manageIcon from '../assets/users.svg';
import billingIcon from '../assets/receipt.svg';
import supportIcon from '../assets/users.svg';
import HeaderLayout from './header';

const { Content, Sider } = Layout;

function getItem(label, key, icon, path, children) {
  return { key, icon, path, children, label };
}

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [menuItems, setMenuItems] = useState([]);


  const { reports } = useSelector((state) => state.config);

  useEffect(() => {
    if (reports && reports.length) {
      const reportsMenuItems = reports.map((report) =>
        getItem(report.text, report.index, null, `/reports/${report.dashboardID}`)
      );
      setMenuItems((prevState) => [
        { type: 'divider' },
        getItem('Dashboard', 'dashboard', <img src={dashboardIcon} alt="dashboard" />, '/dashboard'),
        { type: 'divider' },
        getItem('Knowledge Base', 'knowledge-base', <img src={contentIcon} alt="content" />, '/knowledge-base'),
        { type: 'divider' },
        getItem('FaceBot', 'facebot', <img src={manageIcon} alt="content" />, '/facebot'),
        { type: 'divider' },
        getItem('Reports', 'reports', <img src={dashboardIcon} alt="dashboard" />, '/reports', reportsMenuItems),
        { type: 'divider' },
        getItem('Billing', 'billing', <img src={billingIcon} alt="billing" />, '/billing'),
        { type: 'divider' },
        getItem('Support', 'support', <img src={supportIcon} alt="support" />, '/support'),
      ]);
    }
  }, [reports]);

  // Find menu key by pathname
  const findActiveKey = useCallback((items, path) => {
    for (const item of items) {
      if (item.path === path) return item.key; // Match exact path
      if (item.children) {
        const foundKey = findActiveKey(item.children, path);
        if (foundKey) return foundKey;
      }
    }
    return null;
  }, []);

  // Update active menu item when location changes
  useEffect(() => {
    const activeKey = findActiveKey(menuItems, location.pathname) || 'dashboard'; // Default to dashboard
    setSelectedKeys([activeKey]);
  }, [location.pathname, menuItems]);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();


  return (
    <Layout>
      <HeaderLayout />

      <Layout>
        <Sider width={250} collapsible collapsed={collapsed} onCollapse={setCollapsed}>
          <Menu
            mode="inline"
            theme="dark"
            selectedKeys={selectedKeys}
            // defaultOpenKeys={['sub1']}
            items={menuItems}
            onClick={({ key }) => {
              const findPath = (items, key) => {
                for (let item of items) {
                  if (item.key === key) return item.path;
                  if (item.children) {
                    const childPath = findPath(item.children, key);
                    if (childPath) return childPath;
                  }
                }
                return null;
              };

              const path = findPath(menuItems, key);
              if (path) navigate(path);
            }}
          />
        </Sider>

        <Layout style={{ padding: '14px' }}>
          <Content
            style={{
              padding: 14,
              margin: 0,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
              overflow: 'auto',
              maxHeight: 'calc(100vh - 64px)',
              minHeight: 'calc(96vh - 64px)',
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
